/*
 * Lemonade Training Oy, copy rights, all right reserved.
 */
import React from "react";

/** Holds a date's place while the gym's zone loads. A span, so it can sit inside a sentence. */
export const PendingDate: React.FC = () => (
  <span
    aria-hidden="true"
    data-testid="date-pending"
    className="inline-block h-[1em] w-24 animate-pulse rounded-md bg-muted align-middle"
  />
);

const SLOT = "\u0000";

/** `copy` with its date, or with the date's place held while the date is still null. */
export function withPendingDate(
  copy: (date: string) => string,
  date: string | null
): React.ReactNode {
  if (date !== null) return copy(date);
  const [before, after = ""] = copy(SLOT).split(SLOT);
  return (
    <>
      {before}
      <PendingDate />
      {after}
    </>
  );
}
